import { Routes } from '@angular/router';
import { roleGuard } from '@webapp/auth/guards';
import { DashboardLayoutComponent } from '@webapp/core/ui/layouts/dashboard-layout/dashboard-layout.component';
import { UserRole } from './interfaces/users.interface';
import { CreateAdminPageComponent } from './ui/pages/create-admin-page/create-admin-page.component';
import { MyProfilePageComponent } from './ui/pages/my-profile-page/my-profile-page.component';
import { UsersDetailPageComponent } from './ui/pages/users-detail-page/users-detail-page.component';
import { UsersPageComponent } from './ui/pages/users-page/users-page.component';

export const routes: Routes = [
	{
		path: '',
		component: DashboardLayoutComponent,
		children: [
			{
				path: 'nuevo',
				component: CreateAdminPageComponent,
				canActivate: [roleGuard([UserRole.SUPERADMIN])],
			},
			{
				path: 'perfil',
				component: MyProfilePageComponent,
			},
			{
				path: ':id',
				component: UsersDetailPageComponent,
			},
			{
				path: '',
				component: UsersPageComponent,
			},
		],
	},
];

